import React, { useState, useEffect } from 'react';
//import 'bulma/css/bulma.min.css';
import '../view-archer-styles.css';

// material-ui: theme, colors, icons
import { Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, FormGroup, MenuItem, Radio, RadioGroup, FormControlLabel, InputLabel, Select, Stack} from '@mui/material/';

//components import
import ArcherIssueListing from '../dataObjects/ArcherIssueListing';
import AlertInfoDialog from '../../../components/elements/AlertInfoDialog';
import AlertInfo from '../../../dataObjects/AlertInfo';

interface Props {
    isNewLetterDialogOpen: boolean,
    cpfId: number;
    filerIssues?: ArcherIssueListing[];
    closeNewLetterDialog: (newLetterAdded:boolean)=> void
}


/* ALL LETTER TYPES */
const LetterTypes = [
    {
        letterTypeCode: 10,
        letterTypeDescription: 'AUDIT-RELATED'
    },
    {
        letterTypeCode: 20,
        letterTypeDescription: 'ACKNOWLEDGMENTS'
    },
    {
        letterTypeCode: 30,
        letterTypeDescription: 'ORGANIZATION-RELATED'
    },
    {
        letterTypeCode: 40,
        letterTypeDescription: 'CLOSING-RELATED'
    },
]

const DefaultLetterType = 10;

const AuditLetterTypes = [
    {
        letterTemplateId: 1,
        letterTemplateCode: 'AUDIT'
    },
    {
        letterTemplateId: 2,
        letterTemplateCode: 'AUDIT-REPLY'
    },
    {
        letterTemplateId: 3,
        letterTemplateCode: 'AUDIT-FOLLOWUP'
    },
]

const DefaultAuditLetterType = 2;

const AcknowledgeLetterTypes = [
    {
        letterTemplateId: 11,
        letterTemplateCode: 'ACK-OLD-TREAS-OBLIGATION'
    },
    {
        letterTemplateId: 12,
        letterTemplateCode: 'ACK-T101'
    },
    {
        letterTemplateId: 13,
        letterTemplateCode: 'ACK-NEED-TREASURER'
    },
    {
        letterTemplateId: 14,
        letterTemplateCode: 'ACK-D103'
    },
    {
        letterTemplateId: 15,
        letterTemplateCode: 'ACK-D104'
    },
    {
        letterTemplateId: 16,
        letterTemplateCode: 'ACK-COP'
    },
    {
        letterTemplateId: 17,
        letterTemplateCode: 'ACK-SFI-REQUIRED'
    },
]


const OrganizationLetterTypes = [
    {
        letterTemplateId: 10,
        letterTemplateCode: 'ORG'
    },
    {
        letterTemplateId: 31,
        letterTemplateCode: 'NEW-BANK'
    },
    {
        letterTemplateId: 32,
        letterTemplateCode: 'BANK-NEW-FILER'
    }
]

const OrganizationLetterRelatedIssues = [
    {
        issueTypeCode: 361,
        issueTypeDescription: 'External Activity Report'
    },
    {
        issueTypeCode: 362,
        issueTypeDescription: 'Transition-In Report'
    },
    {
        issueTypeCode: 351,
        issueTypeDescription: 'Appointment of Depository Bank'
    },
]

const ClosingLetterTypes = [
    {
        letterTemplateId: 18,
        letterTemplateCode: 'CLOSING'
    },
    {
        letterTemplateId: 19,
        letterTemplateCode: 'DISS-SUGG'
    },
    {
        letterTemplateId: 20,
        letterTemplateCode: 'ADMIN-CLOSE'
    },
    {
        letterTemplateId: 33,
        letterTemplateCode: 'BANK-FILER-CLOSING'
    },
]

const NewArcherLetterDialog = (props:Props) => {

    // initial state
    //let issues: ArcherIssueListing[] = new Array();
    const [outstandingIssues, setIssues] = useState<ArcherIssueListing[]>();
    const [selectedLetterType, setLetterType] = useState(DefaultLetterType);
    const [selectedLetterTemplateId, setLetterTemplate] = useState(DefaultAuditLetterType);
    const [selectedIssueIds, setSelectedIssueIds] = useState<number[]>([]);
    const [selectedIssueTypeCodes, setSelectedIssueTypeCodes] = useState<number[]>([]);

    useEffect(() => {
        if (props.filerIssues) {
            setIssues(props.filerIssues);
        }
    }, []);

    const handleClose = () => {
        props.closeNewLetterDialog(false);
    };

    const toggleLetterTypes = (event: any) => {
        let type = event.target.value;
        setLetterType(type);
    }

    const updateLetterTemplateId = (event: any) => {
        let templateId = event.target.value;
        setLetterTemplate(templateId);
    }

    const handleIssueCheckbox = (event: any) => {
        let issueId = event.target.value;
        if (event.target.checked) {
            addIssueToLetter(issueId);
        }
        else {
            removeIssueFromLetter(issueId);
        }
    }

    const addIssueToLetter = (issueId: number) => {
        setSelectedIssueIds([...selectedIssueIds, issueId]);
    }

    const removeIssueFromLetter = (issueId: number) => {
        setSelectedIssueIds(selectedIssueIds.filter(id => id !== issueId));
    }

    const handleIssueTypeCheckbox = (event: any) => {
        let issueTypeCode = event.target.value;
        if (event.target.checked) {
            addIssueTypeCodeToLetter(issueTypeCode);
        }
        else {
            removeIssueTypeCodeFromLetter(issueTypeCode);
        }
    }

    const addIssueTypeCodeToLetter = (issueTypeCode: number) => {
        setSelectedIssueTypeCodes([...selectedIssueTypeCodes, issueTypeCode]);
    }

    const removeIssueTypeCodeFromLetter = (issueTypeCode: number) => {
        setSelectedIssueTypeCodes(selectedIssueTypeCodes.filter(code => code !== issueTypeCode));
    }

    const createArcherLetter = () => {
        //call back: update parent's state - draft letter list
        var params = [
            `cpfId=${props.cpfId}`,
            `letterTemplateId=${selectedLetterTemplateId}`,
            `issueIds=${selectedIssueIds.toString()}`,
            `issueTypeCodes=${selectedIssueTypeCodes.toString()}`
        ].join('&');

        let url = `/Archer3/AddLetter?${params}`;
        fetch(url)
            .then(result => result.json())
            .then(result => {
                if (result.isError) {
                    let info = {
                        type: 'error',
                        title: 'Error: AddLetter',
                        errorMessage: result.errorMessage,
                        secondaryErrorMessage: result.secondaryErrorMessage
                    };
                    setAlertInfo(info);
                    setAlertInfoDialog(true);
                }
                else {
                    //add: letter created successfully
                    props.closeNewLetterDialog(true);
                }
            })
    }

    const displayLetterOptions = () => {
        switch (selectedLetterType) {
            case 10:
                return (
                    <>
                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <Select
                                value={selectedLetterTemplateId}
                                onChange={updateLetterTemplateId}
                            >{
                                    AuditLetterTypes.map((letterType) =>
                                        <MenuItem key={letterType.letterTemplateId}
                                            value={letterType.letterTemplateId}>
                                            {letterType.letterTemplateCode}
                                        </MenuItem>
                                    )
                                }
                            </Select>
                        </FormControl>
                        <FormControl>
                            <FormLabel>Outstanding Issues</FormLabel>
                            <FormGroup>
                                {
                                    outstandingIssues && 
                                    outstandingIssues.map((issue, index) =>
                                        <FormControlLabel
                                            control={
                                                <Checkbox/>
                                            }
                                            value={issue.issueId}
                                            key={issue.issueId}
                                            label={`${issue.issueTypeCode} ${issue.header} - ${issue.date}`}
                                            onChange={handleIssueCheckbox}
                                        />
                                    )
                                }
                            </FormGroup>
                        </FormControl>
                    </>
                );
            case 20:
                return (
                    <FormControl>
                        <RadioGroup>
                            {
                                AcknowledgeLetterTypes.map((letterType, index) =>
                                    <FormControlLabel
                                        control={
                                            <Radio />
                                        }
                                        value={letterType.letterTemplateId}
                                        key={letterType.letterTemplateId}
                                        label={letterType.letterTemplateCode}
                                        onChange={updateLetterTemplateId}
                                    />
                                )
                            }
                        </RadioGroup>
                    </FormControl>
                );
            case 30:
                return (
                    <>
                        <FormControl>
                            <RadioGroup>
                                {
                                    OrganizationLetterTypes.map((letterType, index) =>
                                        <FormControlLabel
                                            control={
                                                <Radio />
                                            }
                                            value={letterType.letterTemplateId}
                                            key={letterType.letterTemplateId}
                                            label={letterType.letterTemplateCode}
                                            onChange={updateLetterTemplateId}
                                        />
                                    )
                                }
                            </RadioGroup>
                        </FormControl>
                        <FormControl>
                            <FormLabel>Issues</FormLabel>
                            <FormGroup>
                                {
                                    OrganizationLetterRelatedIssues.map((issue, index) =>
                                        <FormControlLabel
                                            control={
                                                <Checkbox/>
                                            }
                                            key={issue.issueTypeCode}
                                            value={issue.issueTypeCode}
                                            label={`${issue.issueTypeCode} ${issue.issueTypeDescription}`}
                                            onChange={handleIssueTypeCheckbox}
                                        />
                                    )
                                }
                            </FormGroup>
                        </FormControl>
                    </>
                ); 
            case 40:
                return (
                    <FormControl>
                        <RadioGroup>
                            {
                                ClosingLetterTypes.map((letterType, index) =>
                                    <FormControlLabel
                                        control={
                                            <Radio />
                                        }
                                        value={letterType.letterTemplateId}
                                        key={letterType.letterTemplateId}
                                        label={letterType.letterTemplateCode}
                                        onChange={updateLetterTemplateId}
                                    />
                                )
                            }
                        </RadioGroup>
                    </FormControl>
                );
            default:
                return (<></>);
        }
    }

    /*Error Handling*/
    const [isAlertInfoDialogOpen, setAlertInfoDialog] = useState(false);
    const [alertInfo, setAlertInfo] = useState<AlertInfo>();
    const closeAlertInfoDialog = () => {
        setAlertInfoDialog(false);
    }

    return (
        <div>
            <Dialog
                open={props.isNewLetterDialogOpen}
                onClose={handleClose}
                fullWidth={true}
                maxWidth={'sm'}
            >
                <DialogTitle>New Letter</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ marginTop: 2 }}>
                        <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                            <InputLabel>Letter Type</InputLabel>
                            <Select
                                value={selectedLetterType}
                                label="Lette Type"
                                onChange={toggleLetterTypes}
                            >{
                                    LetterTypes.map((letterType) =>
                                        <MenuItem key={letterType.letterTypeCode} value={letterType.letterTypeCode}>{letterType.letterTypeDescription}</MenuItem>
                                )
                             }
                            </Select>
                        </FormControl>
                        <>
                            {displayLetterOptions()}
                        </>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} variant="contained" color="warning" size="small">Cancel</Button>
                    <Button onClick={createArcherLetter} variant="contained" color="success" size="small">Create</Button>
                </DialogActions>
            </Dialog>
            {
                alertInfo &&
                <AlertInfoDialog isAlertInfoDialogOpen={isAlertInfoDialogOpen} alertInfo={alertInfo} closeAlertInfoDialog={closeAlertInfoDialog}></AlertInfoDialog>
            }
        </div>
    )
}

export default NewArcherLetterDialog;